<template>
  <div class="virtualCurrency">
    <div class="virtualCurrency-left">
      <my-tree
        v-model="filterText"
        :treeData="treeData"
        @recharge="recharge"
        :defaultProps="defaultProps"
        icon="icon-fangdajing"
        treeIcon="icon-kehu"
        :onoff="true"
      ></my-tree>
    </div>
    <div class="virtualCurrency-right" v-loading="loading">
      <div class="virtualCurrency-right__info">
        <div class="info_tab">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="充值记录" name="1" />
            <el-tab-pane label="划拨记录" name="2" />
            <el-tab-pane label="消费记录" name="3" />
          </el-tabs>
        </div>
        <el-select
          v-if="activeName == '3'"
          style="margin-right:10px"
          size="small"
          v-model="type"
          placeholder="请选择"
        >
          <el-option label="续费" :value="1"></el-option>
          <el-option label="叠加包" :value="2"></el-option>
          <el-option label="保号" :value="3"></el-option>
        </el-select>
        <el-select
          v-if="activeName == '2'"
          style="margin-right:10px"
          size="small"
          v-model="codeName"
          filterable
          remote
          reserve-keyword
          placeholder="请输入客户代码"
          :remote-method="remoteMethod"
          :loading="loadingCode"
        >
          <el-option
            v-for="item in codeData"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-date-picker
          type="datetime"
          placeholder="开始时间"
          value-format="yyyy-MM-dd HH:mm:ss"
          size="small"
          v-model="params.startTime"
        ></el-date-picker>
        <span class="split-line"></span>
        <el-date-picker
          type="datetime"
          placeholder="结束时间"
          value-format="yyyy-MM-dd HH:mm:ss"
          size="small"
          v-model="params.endTime"
        ></el-date-picker>
        <el-button type="primary" size="small" @click="hanlderOnquery">查 询</el-button>
        <el-button
          type="primary"
          size="small"
          v-if="activeName == '3'"
          @click="handlerRenew(0)"
        >续 费</el-button>
        <el-button
          type="primary"
          size="small"
          v-if="activeName == '3'"
          @click="handlerOverlay"
        >叠加包</el-button>
        <el-button
          type="primary"
          size="small"
          v-if="activeName == '3'"
          @click="handlerRenew(2)"
        >保号</el-button>
        <div class="fr">
          登陆账户:
          <span>{{$store.state.LOGINUSER.userName}}</span> 虚拟币:
          <span>{{totalCorn.corn || 0}}</span>
          <el-button type="primary" size="small" @click="handlerExport">导出</el-button>
        </div>
      </div>
      <el-table
        :data="tableData"
        stripe
        size="small"
        style="width: 100%;padding-bottom:20px;border-bottom:1px solid #eee;"
        height="calc(100% - 170px)"
        border
      >
        <el-table-column type="index" width="50" label="序号" />
        <el-table-column
          :prop="item.prop"
          align="center"
          :label="item.lable"
          :min-width="item.width || 110"
          v-for="(item,index) in tableHeader[Number(activeName) - 1]"
          :key="index"
        >
          <template #default="{row}">
            <div
              style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap;cursor:pointer;"
              v-if="item.prop == 'content'"
              @click="showSim=true;Sim=row[item.prop];"
            >{{row[item.prop]}}</div>
            <span v-else>{{row[item.prop]}}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page.sync="params.pageNumber"
        @size-change="sizeChange"
        @current-change="currentChange"
        :page-sizes="[100, 200, 300, 400]"
        :page-size.sync="params.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="params.totalNum"
      />
    </div>
    <el-dialog
      title="虚拟币划拨"
      :visible.sync="rechargeOnoff"
      :close-on-click-modal="false"
      width="400px"
    >
      <div class="recharge_div">
        <el-row>
          <el-col :span="6">划拨币数：</el-col>
          <el-col :span="18">
            <el-input
              type="number"
              size="small"
              :min="1"
              v-model.number.trim="rechargeParams.corn"
              @input="handleTotal"
            />
          </el-col>
          <el-col :span="6">单价：</el-col>
          <el-col :span="18">
            <el-input
              type="number"
              size="small"
              :min="1"
              v-model.number.trim="rechargeParams.price"
              @input="handleTotal"
            />
          </el-col>
          <el-col :span="6">总价：</el-col>
          <el-col :span="18">
            <el-input
              type="text"
              size="small"
              :disabled="true"
              v-model="rechargeParams.unitPrice"
            />
          </el-col>
          <el-col :span="6" v-if="passwordFlag == 1">密码：</el-col>
          <el-col :span="18" v-if="passwordFlag == 1">
            <el-input
              type="password"
              size="small"
              v-model="rechargeParams.secondPassword"
            />
          </el-col>
          <el-col :span="6">备注：</el-col>
          <el-col :span="18">
            <el-input type="text" size="small" v-model="rechargeParams.remark" />
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="rechargeOnoff=false">取 消</el-button>
        <el-button type="primary" size="small" @click="handlerRecharge">添加</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="SIM卡号"
      :visible.sync="showSim"
      :close-on-click-modal="false"
      width="400px"
    >
      <div
        style="overflow-y:auto;height:300px;width:100%;word-wrap:break-word;"
      >{{Sim}}</div>
    </el-dialog>
    <renewVue ref="renewVueRef" />
    <OverlayPackage ref="OverlayPackageRef" />
  </div>
</template>
<script>
import myTree from "@/components/myTree/";
import { handleTree } from "@/util/handTree";
import renewVue from "@/components/renew/index.vue";
import { FormTime } from "@/util/common.js";
import OverlayPackage from "@/components/OverlayPackage/index.vue";
export default {
  components: {
    myTree,
    renewVue,
    OverlayPackage
  },
  data() {
    return {
      showSim: false,
      Sim: '',
      type: "",
      loading: false,
      activeName: "1",
      rechargeOnoff: false,
      year: 1,
      params: {
        userId: this.$store.state.LOGINUSER.id,
        pageNumber: 1,
        pageSize: 100,
        totalNum: 0,
        startTime: new Date().Format('yyyy-MM-01 00:00:00'),
        endTime: new Date().Format('yyyy-MM-dd 23:59:59'),
      },
      filterText: '',
      defaultProps: {
        children: "children",
        label: "name",
      },
      treeData: [],
      tableData: [],
      rechargeParams: {
        unitPrice: null,
        transferId: this.$store.state.LOGINUSER.id,
        corn: null,
        remark: '',
        price: null,
        customCode: this.$store.state.LOGINUSER.userCode,
        acceptId: '',
        acceptCode: '',
        secondPassword: ''
      },
      tableHeader: [
        [
          {
            lable: '客户代码',
            prop: 'customCode',
          },
          {
            lable: '金额',
            prop: 'price',
          },
          {
            lable: '充值币数',
            prop: 'corn',
          },
          {
            lable: '操作前币数',
            prop: 'beforeCorn',
          },
          {
            lable: '操作后币数',
            prop: 'afterCorn',
          },
          {
            lable: '时间',
            prop: 'createTime',
          },
          {
            lable: '备注',
            prop: 'remark',
          },
        ],
        [
          {
            lable: '划拨客户',
            prop: 'transferCode',
          },
          {
            lable: '接收客户',
            prop: 'acceptCode',
          },
          {
            lable: '划拨币数',
            prop: 'corn',
          },
          // {
          //   lable:'操作类型',
          //   prop:'operateType',
          // },
          {
            lable: '价格',
            prop: 'price',
          },
          {
            lable: '总价',
            prop: 'unitPrice',
          },
          {
            lable: '操作前币数',
            prop: 'beforeCorn',
          },
          {
            lable: '操作后币数',
            prop: 'afterCorn',
          },
          {
            lable: '备注',
            prop: 'remark',
          },
          {
            lable: '时间',
            prop: 'createTime',
          },
        ],
        [
          {
            lable: '客户代码',
            prop: 'customCode',
          },
          {
            lable: '数量',
            prop: 'number',
          },
          {
            lable: '价格',
            prop: 'price',
          },
          {
            lable: '套餐类型',
            prop: 'combo',
          },
          {
            lable: '消费类型',
            prop: 'type',
          },
          {
            lable: '年限',
            prop: 'years',
          },
          // {
          //   lable:'保号费',
          //   prop:'downRenew',
          // },
          {
            lable: '消费币数',
            prop: 'corn',
          },
          {
            lable: '操作前币数',
            prop: 'beforeCorn',
          },
          {
            lable: '操作后币数',
            prop: 'afterCorn',
          },
          {
            lable: '消费内容',
            prop: 'content',
            width: 200,
          },
          {
            lable: '备注',
            prop: 'remark',
            width: 200,
          },
          {
            lable: '创建时间',
            prop: 'createTime',
            width: '180'
          },
        ]
      ],
      // totalCorn:{},
      list: [],
      codeData: [],
      loadingCode: false,
      codeName: '',
      time: null,
    }
  },
  computed: {
    //判断当前日期是否为当月最后一天
    isDateLast() {
      let MM = parseInt(new Date().Format('MM')) + 1;
      let time = new Date(new Date().Format(`${MM < 10 ? `0${MM}` : MM}-01`)).getTime() - 86400000;
      return FormTime(time);
    },
    //获取支付状态
    passwordFlag() {
      return this.$store.state.passwordFlag;
    },
    totalCorn() {
      return this.$store.state.totalCorn
    }
  },
  created() {
    this.getUsers();
    this.init();
  },
  methods: {
    //分页
    currentChange(val) {
      this.params.pageNumber = val;
      this.hanlderOnquery();
    },
    //页码
    sizeChange(val) {
      this.params.pageSize = val;
      this.hanlderOnquery();
    },
    //总价
    handleTotal() {
      this.rechargeParams.unitPrice = this.rechargeParams.corn * this.rechargeParams.price;
    },
    //批量叠加包
    handlerOverlay() {
      if (this.isDateLast == new Date().Format('MM-dd')) {
        this.$message({
          type: 'warning',
          message: '每月的最后一天不能叠加包'
        })
        return false;
      }
      this.$refs.OverlayPackageRef.renewParams.type = 3;
      this.$refs.OverlayPackageRef.renewParams.sim = '';
      this.$refs.OverlayPackageRef.visible = true;
    },
    //续费
    handlerRenew(activeType) {
      if (this.isDateLast == new Date().Format('MM-dd')) {
        this.$message({
          type: 'warning',
          message: '每月的最后一天不能叠加包'
        })
        return false;
      }
      this.$refs.renewVueRef.renewParams.activeType = activeType
      this.$refs.renewVueRef.renewParams.sim = '';
      this.$refs.renewVueRef.renewParams.data && (this.$refs.renewVueRef.renewParams.data.data.allCorn = 0);
      this.$refs.renewVueRef.renewParams.type = 3;
      this.$refs.renewVueRef.visible = true;
    },
    //客户代码搜索
    remoteMethod(query) {
      if (query !== '') {
        this.loadingCode = true;
        setTimeout(() => {
          this.loadingCode = false;
          this.codeData = this.list.filter(item => {
            return String(item.label).toLowerCase()
              .indexOf(query.toLowerCase()) > -1;
          });
        }, 200);
      } else {
        this.codeData = [];
      }
    },
    //初始化数据
    async init() {
      // const { data } = await this.$API.getUserCornInfo({userId:this.params.userId});
      // this.totalCorn = data;
      // clearTimeout(this.time);
      // this.time = setTimeout(()=>{
      //   this.init();
      // },10000)
    },
    //查询
    async hanlderOnquery() {
      this.loading = true;
      const { totalNum, ...params } = this.params;
      const url = this.activeName == '1' ? 'getRechargeReport' : this.activeName == '2' ? 'getTransferReport' : 'getCornConsumeReport';
      this.activeName == '2' && (
        params.targetId = this.codeName,
        delete params.userId
      )

      this.activeName == '3' && (
        params.type = this.type,
        // params.years = this.year,
        delete params.userId
      );
      this.activeName != '3' && (params.operateType = this.activeName);
      const { data } = await this.$API[url](params);
      this.tableData = data.data.map(item => {
        item.type && (item.type = item.type == 1 ? '续费' : item.type == 2 ? '叠加包' : '保号');
        if (item.type == '保号') { item.years = '' }
        return item;
      });
      this.params.totalNum = data.total;
      setTimeout(() => {
        this.loading = false;
      }, 600);
    },
    //切换记录
    handleClick() {
      this.tableData = [];
    },
    //导出
    handlerExport() {
      const { pageNumber, pageSize, totalNum, ...params } = this.params;

      this.activeName == '2' && (
        params.targetId = this.codeName,
        delete params.userId
      )
      this.activeName == '3' && (
        params.type = this.type,
        delete params.userId
      )
      this.activeName != '3' && (params.operateType = Number(this.activeName));
      let url = this.activeName == '1' ? 'exportRechargeReport' : this.activeName == '2' ? 'exportTransferReport' : 'exportConsumeReport';
      this.$API[url]({ ...params });
    },
    //确认划拨
    async handlerRecharge() {
      try {
        if (!this.rechargeParams.corn) throw { msg: "划拨币数不能为空，且不能为0" };
        if (!this.rechargeParams.price) throw { msg: "价格不能为空，且不能为0" };
        if (this.rechargeParams.corn > this.totalCorn.corn) throw { msg: "划拨数量大于当前账号虚拟币数" };
        const { data } = await this.$API.transferCorn(this.rechargeParams);
        console.log(data);
        data.code == 0 && (
          this.rechargeParams = {
            transferId: this.$store.state.LOGINUSER.id,
            corn: null,
            remark: '',
            price: '',
            customCode: this.$store.state.LOGINUSER.customCode,
            acceptId: '',
            acceptCode: '',
            unitPrice: ''
          },
          this.rechargeOnoff = false,
          this.init()
        )
        if (data.code != undefined) throw { msg: data.msg, code: data.code };
      } catch (data) {
        this.$message({
          type: data.code == 0 ? 'success' : 'warning',
          message: data.msg
        })
      }

    },
    //选择充值
    recharge(data) {
      this.rechargeOnoff = true;
      this.rechargeParams.unitPrice = null;
      this.rechargeParams.corn = 1;
      this.rechargeParams.remark = '';
      this.rechargeParams.price = 1;
      this.rechargeParams.acceptId = data.userId;
      this.rechargeParams.acceptCode = data.customCode;
    },
    // 获取用户列表
    async getUsers() {
      let { id, userName, parentId } = this.$store.state.LOGINUSER;
      let infouser = this.tableData.slice(0, this.tableData.length);
      let user = await this.$API.getNextUserInfo({ userId: this.$store.state.LOGINUSER.id });
      infouser.push({
        userId: id,
        name: userName,
        parentId: parentId
      });
      let data = handleTree(
        infouser,
        this.$store.state.LOGINUSER.parentId,
        "userId",
        "parentId",
        "children"
      );
      data[0].children = [];
      user.data.map(item => {
        this.list.push({
          value: item.userId,
          label: item.customCode
        })
        data[0].children.push({
          name: item.corpName,
          customCode: item.customCode,
          userId: item.userId
        })
      })
      this.treeData = data;
    }
  }
}
</script>
<style lang="scss" scoped>
.virtualCurrency {
  display: flex;
  overflow: hidden;
  position: absolute;
  left: 20px;
  right: 20px;
  top: 20px;
  bottom: 20px;
  .virtualCurrency-left {
    width: 230px;
    padding: 20px;
    margin-right: 20px;
    background: #fff;
    display: flex;
    flex-direction: column;
  }
  .virtualCurrency-right {
    background: #fff;
    flex: 1;
    min-width: 900px;
    position: relative;
    padding: 10px;
    &__info {
      padding: 10px 0 20px 0;
      position: relative;
      > button {
        margin-left: 10px;
      }
      > .fr {
        position: absolute;
        right: 0;
        top: 2px;
        color: #333;
        font-size: 14px;
        > span {
          color: #f56c6c;
          display: inline-block;
          margin: 0 4px;
        }
        > button {
          margin-left: 10px;
        }
      }
    }
  }
  .recharge_div {
    line-height: 34px;
    .el-col {
      margin-bottom: 10px;
      > span {
        color: #f56c6c;
        font-size: 16px;
      }
    }
  }
}
</style>